import { defineMessages } from 'react-intl';

export default defineMessages({
  dealerInventory: {
    id: 'dealerInventory',
    description: 'Quota Details Dealer Inventory Heading',
    defaultMessage: 'Dealer Inventory',
  },
  processingCenter: {
    id: 'processingCenter',
    description: 'Quota Details Processing Center Heading',
    defaultMessage: 'Processing Center',
  },
  inTransitToVPC: {
    id: 'inTransitToVPC',
    description: 'Quota Details In Transit to VPC Heading',
    defaultMessage: 'In Transit to VPC',
  },
  scheduledInProduction: {
    id: 'scheduledInProduction',
    description: 'Quota Details Scheduled/In Production Heading',
    defaultMessage: 'Scheduled/In Production',
  },
  producedNotShipped: {
    id: 'producedNotShipped',
    description: 'Quota Details Produced/Not Shipped Heading',
    defaultMessage: 'Produced/Not Shipped',
  },
  onOrder: {
    id: 'onOrder',
    description: 'Quota Details On Order Heading',
    defaultMessage: 'On Order',
  },
  unsubmitted: {
    id: 'unsubmitted',
    description: 'unsubmitted',
    defaultMessage: 'Unsubmitted',
  },
  projectedPipeline: {
    id: 'projectedPipeline',
    description: 'Quota Details Projected Pipeline Heading',
    defaultMessage: 'Projected Pipeline',
  },
  currentStatusString: {
    id: 'pipelineDropdown.currentStatus',
    description: 'Current Submission Status',
    defaultMessage: 'Current Submission Status',
  },
  recentHistoryFootnote: {
    id: 'recentHistoryFootnote',
    description: 'recent history footnote',
    defaultMessage: 'Recent history may not be reflected in the pipeline',
  },
});
